import React from 'react';
import { HeartPulseIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy-950 px-4 pb-32 pt-12 text-center" data-id="element-192" data-mp="207t2499pvllk">
      <div className="mx-auto max-w-3xl" data-id="element-193" data-mp="2f4juhykz3x1o">
        <p className="flex items-center justify-center gap-2 text-base font-black tracking-wide text-white" data-id="element-194" data-mp="2f3ik7wbs7el0">
          <HeartPulseIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-195" data-mp="2a69xdifoumdf" />
          CRITICAL CARE NURSING BLUEPRINT™
        </p>
        <p className="mt-2 text-sm text-mist" data-id="element-196" data-mp="1mdtj7iz2neje">Created by Rachel Bennett</p>
        <p className="mt-1 text-sm text-mist" data-id="element-197" data-mp="1hiw886i8ev3v">A digital educational reference collection for critical care nursing studies.</p>
        <p className="mt-8 text-xs leading-relaxed text-mist/80" data-id="element-198" data-mp="1rf91525yd4xk">
          <span className="font-bold text-mist" data-id="element-199" data-mp="1rdxyj5o8u381">EDUCATIONAL DISCLAIMER:</span> This product is intended for educational
          and professional reference purposes only. It does not provide patient-specific medical advice, diagnose
          medical conditions, establish validated clinical decision algorithms, or replace professional judgment,
          current evidence, supervised clinical training, institutional protocols, or applicable professional
          guidelines.
        </p>
        <p className="mt-6 text-xs text-mist/70" data-id="element-200" data-mp="1naxiyeptc9bb">© 2026 · All rights reserved.</p>
      </div>
    </footer>;
}